import { useScrollAnimation } from "#/hooks/useScrollAnimation";
import { EstimateForm } from "#/components/shared/EstimateForm";

/**
 * FinalCTA — the home estimate-form section wrapper (light background +
 * scroll-reveal). The form itself lives in `EstimateForm` (shared, reused by
 * `/quote`). Light on purpose: customer-facing forms are never dark on this
 * site (see memory/lessons.md 2026-07-25).
 */
export function FinalCTA() {
  const { ref, isVisible } = useScrollAnimation(0.1);

  return (
    <section id="contact" className="bg-light-bg py-20 lg:py-28">
      <div
        ref={ref}
        className={`mx-auto max-w-4xl px-4 transition-all duration-700 sm:px-6 lg:px-8 ${
          isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
        }`}
      >
        <EstimateForm />
      </div>
    </section>
  );
}
